// The select-all header cell. It selects or deselects only the eligible rows of the current page (in a
// grouped section, its own group's rows, and it is named for that group), reads mixed while some of them
// are selected, and under query-scoped selection (or while bulk work runs) stays checked, focusable and
// aria-disabled: Clear selection is the way out.

import React, { useLayoutEffect, useRef } from 'react'

import { useTable } from '../context'
import { HEADER_LABEL, groupHeaderLabel } from './copy'
import { useSelection } from './useSelection'

const noop = () => {}

export const HeaderCheckbox = () => {
  const { group } = useTable()
  const selection = useSelection()
  const box = useRef(null)
  const { checked, mixed, locked } = selection.header
  const blocked =
    locked || Boolean(selection.pending) || !selection.pageIds.length

  useLayoutEffect(() => {
    if (box.current) box.current.indeterminate = mixed
  })

  return (
    <th className="me-table-control me-table-select" scope="col">
      <input
        ref={box}
        type="checkbox"
        checked={checked}
        onChange={noop}
        // a blocked checkbox keeps its state: the controlled value restores it after the click
        onClick={() => {
          if (!blocked) selection.togglePage()
        }}
        aria-label={group ? groupHeaderLabel(group.title) : HEADER_LABEL}
        aria-checked={mixed ? 'mixed' : undefined}
        aria-disabled={blocked || undefined}
      />
    </th>
  )
}
